/**
 * @Author : zhouqinze
 * @Date : 2019-12-30
 * @Version : 1.0
 * @Content : 侧边栏
 **/
<template>
    <ul class="aboutBar">
    <div class="topSquire"></div>
    <li v-for="(item,index) in thisLiArr" :key="index" @click="gotoPage(index)" :style="{background:thisShowArr[index]?'#018CF4':'#fff',color:thisShowArr[index]?'#fff':'#000'}"><span class="squire" :style="{background:thisShowArr[index]?'#018CF4':'#ccc'}"></span><div><span :style="{display:thisShowArr[index]?'block':'none'}"></span><p>{{item}}</p></div></li>
    <!-- <li><span class="squire"></span><div><span></span><p>资质荣誉</p></div></li>
    <li><span class="squire"></span><div><span></span><p>合作伙伴</p></div></li>
    <li><span class="squire"></span><div><span></span><p>联系我们</p></div></li> -->
    <div class="btmSquire"></div>
    </ul>
</template>

<script>
export default {
    props:['TextArr','routerArr'],
    data() {
        return {
            activeIndex:window.sessionStorage.getItem('sendIndex'),
            showArr:[true,false,false,false],
        }
    },
    methods: {
        gotoPage:function(i){
            // window.console.log()
            this.activeIndex = i
            window.sessionStorage.setItem('sendIndex',i)
            this.$router.push(this.routerArr[i])
            for(let index in this.thisShowArr){
                this.thisShowArr[index] = false
            }
            this.thisShowArr[i]=true;
        }
    },
    computed: {
        thisLiArr:function(){
            return this.TextArr
        },
        thisShowArr:function(){
            // window.console.log(this.$route.path)
            let arr = [...this.showArr]
            // if(this.$route.path == '/')
            if(window.sessionStorage.getItem('sendIndex')){
                let i = window.sessionStorage.getItem('sendIndex')
                for(let index in arr){
                    arr[index] = false
                }
                arr[i] = true
            }
            return arr
        }
    },
}
</script>

<style lang="scss" scoped>
    // .content{
    //         width: 1200px;
    //         height: 100%;
    //         margin: auto;
    //         display: flex;
    //         justify-content: space-between;
            .aboutBar{
                height: 15rem;
                margin-top: 7rem;
                padding-top: 1.875rem;
                margin-left: 10%;
                border-left: .0625rem dotted #ccc;position: relative;
                .topSquire{
                    width: .625rem;
                    height: .625rem;
                    background: #ccc;
                    position: absolute;
                    left: -0.3125rem;
                    top: -0.3125rem;
                }
                .btmSquire{
                    width: .625rem;
                    height: .625rem;
                    background: #ccc;
                    position: absolute;
                    left: -0.3125rem;
                    bottom: 0;
                }
                li{
                    margin-left: 1.5625rem;
                    width: 4.5625rem;
                    height: 2.5rem;
                    background: #018CF4;
                    font-size: .9375rem;
                    color: #000;
                    line-height: 2.5rem;
                    margin-bottom: 1rem;
                    border-radius: .1875rem;
                    cursor: pointer;
                    position: relative;
                    .squire{
                        display: block;
                        width: .25rem;
                        height: .25rem;
                        background: #ccc;
                        position: absolute;
                        left: -1.75rem;
                        top: 50%;
                        transform: translateY(-50%)
                    }
                    div{
                        position: relative;
                        span{
                            display: block;
                            height: 0;
                            border: .3125rem solid transparent;
                            border-right-color: #018CF4;
                            position: absolute;
                            left: -0.625rem;
                            top: 50%;
                            transform: translateY(-50%)
                        }
                    }
                }
                li:nth-child(5){
                    margin-bottom: 0
                }
            }
        // }
</style>